// extracted by mini-css-extract-plugin
export default {"relativeContainer":"toasts_relativeContainer__jicGg","absoluteContainer":"toasts_absoluteContainer__PL8Eq"};